import qs from 'query-string';

export const PARTNER_SIGNIN_PATH = '/partner/signin';

/**
 * 파트너 계정이 기존 로그인을 시도했을 때 이동할 경로. 서버는 자격이 맞아도 세션을 발급하지 않고
 * 200 응답에 기업 코드만 실어 보낸다 — URL 을 서버가 조립하지 않는 것은 오픈 리다이렉트를 막기
 * 위한 것이라, 여기서도 호스트를 붙이지 않는다 (biz 등 현재 호스트를 그대로 유지해야 한다).
 *
 * 필드가 없을 때만 일반 로그인이다. 빈 문자열은 기업 코드를 못 찾은 파트너 계정이라
 * (서버가 fail-closed 로 `''` 를 내려준다) 세션 없이 로그인 성공으로 흘려보내면 안 된다.
 */
export const getPartnerSigninPath = (partnerGroupSlug: string | undefined): string | null => {
  if (partnerGroupSlug === undefined) {
    return null;
  }

  if (partnerGroupSlug === '') {
    return PARTNER_SIGNIN_PATH;
  }

  return qs.stringifyUrl({ url: PARTNER_SIGNIN_PATH, query: { org: partnerGroupSlug } });
};
